// MODIFIED
import React, { useState } from "react";
import AddCardIcon from '@mui/icons-material/AddCard';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RecyclingIcon from '@mui/icons-material/Recycling';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LoanLogsModal from "./components/LoanLogsModal";

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button
} from "../../../../common/APICommon";
import { DynamicFilterBar } from "../../filters/DynamicFilterBar";
import { useFilterManager } from "../../../hooks/useFilterManager";
import { useEmployees } from "../../../hooks/useEmployees";
import { useLoanTransaction } from "../../../hooks/useLoanTransaction";
import { FEATURES } from "../../../../config/features";
import LoanRequestModal from "./components/LoanRequestModal";
import { LoadingSpinner } from "../../../../common/Loading";

const LoanTransactionModule = ({ user, showGeneralMessage }) => {
  const filterManager = useFilterManager(FEATURES.EMPLOYEE_FILTERS || []);
  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    applyFilters,
    resetFilters
  } = filterManager;

  const { employees, loading, handleSearch } = useEmployees(apiFilterPayload, false);
  const { handleSaveLoan, requestLoading } = useLoanTransaction(showGeneralMessage);
  
  const [modalConfig, setModalConfig] = useState({ isOpen: false, mode: "Add", employee: null });
  const [logsModalConfig, setLogsModalConfig] = useState({ isOpen: false, employee: null });
  const [currentPage, setCurrentPage] = useState(1);

  // MODIFIED: Accessors renamed to be explicit based on Backend Models
  const headers = ["Employee ID", "Full Name", "Position", "Type", "Actions"];
  const accessors = [
    "employeeId", // This is the string ID (CM00001)
    "fullName",
    "employeeInformation.positionDescription",
    "employeeInformation.employeeTypeDescription",
    "actions"
  ];

  const actions = [
    {
      name: "Add",
      tooltip: "create",
      icon: <AddCardIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center text-white px-2 py-1 rounded text-[10px] font-bold uppercase",
      function: (row) => setModalConfig({ isOpen: true, mode: "Add", employee: row }),
      visible: true,
    },
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditNoteIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center text-white px-2 py-1 rounded text-[10px] font-bold uppercase",
      function: (row) => setModalConfig({ isOpen: true, mode: "Edit", employee: row }),
      visible: true,
    },
    {
      name: "Overwrite",
      tooltip: "recalculate",
      icon: <RecyclingIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600 flex items-center text-white px-2 py-1 rounded text-[10px] font-bold uppercase",
      function: (row) => setModalConfig({ isOpen: true, mode: "Recalculate", employee: row }),
      visible: true,
    },
    {
      name: "Logs", // ADDED
      tooltip: "view logs",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-cyan-400 hover:bg-cyan-500 flex items-center text-white px-2 py-1 rounded text-[10px] font-bold uppercase",
      function: (row) => setLogsModalConfig({ isOpen: true, employee: row }),
      visible: true,
    },
  ];

  return (
    <>
      <div className="space-y-4">
        <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm" style={{ border: "1px solid #d7d7d7" }}>
          <span className="text-sm font-bold text-gray-400 uppercase tracking-widest block mb-4">Filters</span>
          <DynamicFilterBar
            requestedFilters={FEATURES.EMPLOYEE_FILTERS || []}
            activeFilterState={activeFilterState}
            onFilterChange={onFilterChange}
            showButtons={false}
          />
          <div className="flex gap-2 mt-5 border-t pt-4">
            <Button name="GENERATE" className="bg-blue-600 text-white px-5 py-2 border-none rounded cursor-pointer font-bold text-xs" onClick={applyFilters} />
            <Button name="CLEAR" className="bg-gray-400 text-white px-5 py-2 border-none rounded cursor-pointer text-xs" onClick={resetFilters} />
          </div>
        </div>

        <SearchBar handleFilter={handleSearch} />

        <CreateTable
          tableName="LoanTransactionsEmployeeTable"
          headers={headers}
          accessors={accessors}
          data={employees}
          actions={actions}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={employees?.length || 0}
          loading={loading}
        />

      </div>
      {modalConfig.isOpen && (
        <LoanRequestModal
          isOpen={modalConfig.isOpen}
          onClose={() => setModalConfig({ ...modalConfig, isOpen: false })}
          mode={modalConfig.mode}
          employee={modalConfig.employee}
          onSave={handleSaveLoan}
          loading={requestLoading}
          user={user}
          showGeneralMessage={showGeneralMessage}
        />
      )}

      <LoanLogsModal
        isOpen={logsModalConfig.isOpen}
        onClose={() => setLogsModalConfig({ ...logsModalConfig, isOpen: false })}
        employee={logsModalConfig.employee}
        showGeneralMessage={showGeneralMessage}
      />

      <LoadingSpinner loading={loading || requestLoading} />
    </>
  );
};

export default LoanTransactionModule;